import React from 'react';
import { Layout, Spin } from 'antd';

import ErrorHTML from 'components/common/form/ErrorHTML';
import GuestHeader from 'components/layout/guest/GuestHeader';
import GuestFooter from 'components/layout/guest/GuestFooter';
import { GuestRoutes } from 'components/Routes';
import LoginSSO from 'components/views/guest/LoginSSO';

const GuestLayout = ({ getCompanyInfo: { data = {}, meta } }) => (
    <Layout className="guest-content">
        <div className="guest-wrap">
            <div className="guest-layout">
                <div className="guest-block">
                    <GuestHeader company={data} />

                    <Spin spinning={meta.pending}/>
                    <ErrorHTML className="alert-clean" meta={meta} />

                    { data.sso ? (
                        <LoginSSO />
                    ) : !meta.error && (
                        <GuestRoutes />
                    )}
                </div>
                { meta.error && <GuestFooter company={data} /> }
            </div>
        </div>
    </Layout>
);

export default GuestLayout;
